import { normalizeIncomingPath } from './deepLinks'
import React from 'react'
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom'
import { Capacitor, PluginListenerHandle, registerPlugin } from '@capacitor/core'
import Dashboard from '../pages/Dashboard'
import Account from '../pages/Account'
import Login from '../pages/Login'
import CreateAccount from '../pages/CreateAccount'
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ResetPassword'
import Privacy from '../pages/Privacy'
import Terms from '../pages/Terms'
import Admin from '../pages/Admin'

type UrlOpenEvent = { url: string }
type AppLaunchUrl = { url?: string }
type AppPlugin = {
  addListener(
    eventName: 'appUrlOpen',
    listenerFunc: (event: UrlOpenEvent) => void
  ): Promise<PluginListenerHandle>
  getLaunchUrl(): Promise<AppLaunchUrl>
}

const CapacitorApp = registerPlugin<AppPlugin>('App')

function DeepLinkBridge(): null {
  const history = useHistory()

  React.useEffect(() => {
    if (!Capacitor.isNativePlatform()) return

    const navigateToDeepLink = (event: UrlOpenEvent): void => {
      const nextPath = normalizeIncomingPath(event.url || '')
      console.info('[deep-link] appUrlOpen', { raw: event.url, nextPath })
      if (
        nextPath !==
        window.location.pathname + window.location.search + window.location.hash
      ) {
        history.push(nextPath)
      }
    }

    const sub = CapacitorApp.addListener('appUrlOpen', navigateToDeepLink)

    CapacitorApp.getLaunchUrl()
      .then((launchData) => {
        console.info('[deep-link] getLaunchUrl', launchData)
        if (launchData?.url) {
          navigateToDeepLink({ url: launchData.url })
        }
      })
      .catch((error) => {
        console.warn('[deep-link] getLaunchUrl unavailable', error)
      })

    return () => {
      sub
        .then((listener) => listener.remove())
        .catch(() => {
          // no-op: listener cleanup best effort
        })
    }
  }, [history])

  return null
}

export default function AppRouter(): JSX.Element {
  // const { appState } = useContext(AppContext)
  // const isAuthenticated = appState.user.id

  return (
    <Router>
      <div className="App">
        <DeepLinkBridge />
        {/* <link
          href="https://fonts.cdnfonts.com/css/motiva-sans"
          rel="stylesheet"
        /> */}

        <Switch>
          <Route path="/lists/:listId/play">
            <Dashboard />
          </Route>
          <Route path="/play/:mode">
            <Dashboard />
          </Route>
          <Route path="/polls/:pollId/:pollAction?">
            <Dashboard />
          </Route>
          <Route path="/createAccount">
            <CreateAccount />
          </Route>
          <Route path="/forgotPassword">
            <ForgotPassword />
          </Route>
          <Route path="/resetPassword">
            <ResetPassword />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/account">
            <Account />
          </Route>
          <Route path="/admin">
            <Admin />
          </Route>
          <Route path="/privacy">
            <Privacy />
          </Route>
          <Route path="/terms">
            <Terms />
          </Route>
          <Route path="/share/game">
            <Dashboard />
          </Route>
          <Route path="/share/poll">
            <Dashboard />
          </Route>
          <Route path="/share">
            <Dashboard />
          </Route>
          <Route path="/">
            <Dashboard />
          </Route>
        </Switch>
      </div>
    </Router>
  )
}
